module.exports = __webpack_public_path__ + "static/img/data_analysis.956d577b.png";